import { Component, OnDestroy } from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ModalComponent } from '../modal/modal.component';
import { ButtonComponent } from '../button/button.component';
import { ModalService, ModalConfig } from '@shared/services/modal.service';
import { Subscription } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-modal-host',
  imports: [NgIf, NgTemplateOutlet, ModalComponent, ButtonComponent, TranslocoModule],
  templateUrl: './modal-host.component.html',
  styles: ``
})
export class ModalHostComponent implements OnDestroy {
  config: ModalConfig | null = null;
  private sub: Subscription;

  constructor(public modal: ModalService) {
  this.sub = this.modal.modal$.subscribe((c: ModalConfig | null) => this.config = c);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onClose() {
    this.modal.close();
  }

  confirmYes() {
    this.modal.resolveConfirm(true);
  }

  confirmNo() {
    this.modal.resolveConfirm(false);
  }
}
